import { rankWith, isBooleanControl } from '@jsonforms/core';

export default rankWith(
    3, isBooleanControl
);
